import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { FeedbackConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CustomerFeedbackFormService } from './api/customerFeedbackForm.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class FeedbackApiModule {
    public static forRoot(configurationFactory: () => FeedbackConfiguration): ModuleWithProviders<FeedbackApiModule> {
        return {
            ngModule: FeedbackApiModule,
            providers: [ { provide: FeedbackConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: FeedbackApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('FeedbackApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
